import React from 'react'
import { t } from 'ttag'
import './DomainStatus.scss'

interface IDomainStatus {
  // Accepts domain statuses ('verified', 'pending', 'failed')
  // and generic statuses ('active', 'inactive') for reuse across admin views
  status: string
}

/**
 * Pill-shaped status badge.
 * Follows the same pattern as TeamStatus.
 * Supports domain statuses and generic active/inactive.
 */
export default function DomainStatus(props: IDomainStatus) {
  const { status } = props

  // Normalize to lowercase so CSS classes always match
  const normalized = status?.toLowerCase() || ''

  // Map generic statuses to existing CSS classes
  const cssClass = normalized === 'active' ? 'verified' : normalized === 'inactive' ? 'pending' : normalized

  const label = () => {
    switch (normalized) {
      case 'verified':
        return t`Verified`
      case 'pending':
        return t`Pending`
      case 'failed':
        return t`Failed`
      case 'active':
        return t`Active`
      case 'inactive':
        return t`Inactive`
      default:
        return status
    }
  }

  return (
    <div className={`domain-status domain-status__${cssClass}`}>
      <span className="domain-status-dot"></span>
      {label()}
    </div>
  )
}
